import React from 'react';
import { Box, Button } from '@mui/material';
import { FaPlus, FaCheck, FaTrash, FaFileExport } from 'react-icons/fa';

const ActionButtons = ({
    selectedEntries = [],
    addNewEntry,
    approveSelected,
    handleBulkDelete,
    exportData,
    loading = {}
}) => {
    return (
        <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button
                variant="contained"
                color="primary"
                startIcon={<FaPlus />}
                onClick={addNewEntry}
                sx={{ 
                    minWidth: '120px',
                    backgroundColor: '#1976d2',
                    '&:hover': {
                        backgroundColor: '#1565c0'
                    }
                }}
            >
                Add Entry
            </Button>

            {selectedEntries.length > 0 && (
                <>
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<FaCheck />}
                        onClick={approveSelected}
                        disabled={loading.approveEntries}
                        sx={{ 
                            minWidth: '140px',
                            backgroundColor: '#2e7d32',
                            '&:hover': {
                                backgroundColor: '#1b5e20'
                            }
                        }}
                    >
                        {loading.approveEntries 
                            ? 'Approving...' 
                            : `Approve (${selectedEntries.length})`
                        }
                    </Button>

                    <Button
                        variant="contained"
                        color="error"
                        startIcon={<FaTrash />}
                        onClick={handleBulkDelete}
                        disabled={loading.bulkDelete}
                        sx={{ 
                            minWidth: '130px',
                            backgroundColor: '#d32f2f',
                            '&:hover': {
                                backgroundColor: '#c62828'
                            }
                        }}
                    >
                        {loading.bulkDelete 
                            ? 'Deleting...' 
                            : `Delete (${selectedEntries.length})`
                        }
                    </Button>
                </>
            )}

            {/* <Button
                variant="outlined"
                color="secondary"
                startIcon={<FaFileExport />}
                onClick={() => exportData('excel')}
                sx={{ 
                    minWidth: '120px',
                    borderColor: '#9c27b0',
                    color: '#9c27b0',
                    '&:hover': {
                        borderColor: '#7b1fa2',
                        backgroundColor: 'rgba(156, 39, 176, 0.04)'
                    }
                }}
            >
                Export
            </Button> */}
        </Box>
    );
};

export default ActionButtons;